import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import api from "../lib/api";

export default function AuthCallback() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState("");

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");
      const isGoogle = params.get("google");
      const redirectTo = params.get("redirect") || "/";
      if (token && isGoogle) {
        try { await api.post("/auth/logout"); } catch {}
        localStorage.removeItem("em_token");
        document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + window.location.hostname;
        localStorage.setItem("em_token", token);
        try {
          const { data: me } = await api.get("/auth/me");
          await refresh();
          toast.success("Signed in with Google!");
          if (me?.needs_profile_completion) {
            nav(`/complete-profile?redirect=${encodeURIComponent(redirectTo)}`);
          } else {
            nav(redirectTo);
          }
        } catch {
          setErr("Sign-in failed. Please try again.");
        }
        return;
      }
      setErr("Sign-in failed. Please try again.");
    };
    handleCallback();
  // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-[60vh] grid place-items-center">
      <div className="text-center">
        {err
          ? <><p className="font-display text-xl text-red-500">{err}</p><a href="/login" className="btn-primary mt-4 inline-flex">Back to login</a></>
          : <p className="font-display text-xl">Signing you in…</p>
        }
      </div>
    </div>
  );
}
